// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2yEKR","question":"Question_question__3irDT","description":"Question_description__R-0qY"};